<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div style="width: 100%; height: auto">
        <div class="centerHead__users_main__1fT82 undefined" style="background-image: url('/static/image/bg.dc5a82a281e10420d019c23e957bd692.png')">
          <div class="centerHead__users_content__3jK8m">
            <div class="index__user_left_kok__2nleM undefined">
              <div class="index__activeIcons__Z1BgD">
                <div>
                  <img src="/static/image/deposit.0947ecf747f936e9f9a20e20fe3a5806.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/deposit_active.dde1618b4c1e6b81d7129e30d1997845.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/static/image/deposit_hover.583baa477ab9c2ee3d3b6b7c2bc89073.png"
                    style="filter: blur(8px); will-change: transform, opacity"
                  />
                </div>
                <div>
                  <img src="/static/image/transfer.cada0b68f36cabf40a9956d59bb9b1fe.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/transfer_active.357f49245ec9940adb0badebb8583edf.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/static/image/transfer_hover.d4d26662bdb027d7e27b04313a5dd97c.png"
                    style="filter: blur(8px); will-change: transform, opacity"
                  />
                </div>
                <div>
                  <img src="/static/image/withdrawal.6fc5b140031dfbd3b77cc6aafbf4fe47.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/withdrawal_active.fd787d889022584f7ac4976505862b6e.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/static/image/withdrawal_hover.100ff3a693f47e8786e9fbab52280c5b.png"
                    style="filter: blur(8px); will-change: transform, opacity"
                  />
                </div>
                <div>
                  <img src="/static/image/0.fa44efc644589909c1e16f3dedb07626.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/0-1.79122c3d6a38f284408a86fbc807b0a9.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/1.404d07d89fe207dd01ddbbe812b97c01.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/1-1.87a1c8da3d4ffd24d6197a21d4a769e3.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/2.c21324096c848ea53d629c3f8fc20631.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/2-1.d4198f6fdf5999d2f49d22345981a181.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/3.983decfccd2bdc503c4c42fdf583de89.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/3-1.d5283afeb84b6fee05f9fd6d682d3d11.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/4.d40de41e77eefd350e82d9a3534b25c3.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/4-1.bf6a3939dfd04c242e2da01250df2ad5.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/5.c6da83c12132a221cff965aefc959904.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/5-1.fdfceb407e70551f81fe01def26fa7ec.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/6.d62837c7256bdcb8be821f3ad2972ea2.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/6-1.bb8698837dee80be2e5f31658cd0d4da.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/7.31525e63cb61f29775d42bb0d42d2027.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/7-1.292dc81e3d6f153bdff5393e56dedd29.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/8.a0d43ac0366a91d5f8dd621f8c7e8de8.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/8-1.2267384b0cfb773154c159beda0a14da.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
                <div>
                  <img src="/static/image/9.dfa5c7b10ef63f38af88d933f93af398.png" style="filter: blur(8px); will-change: transform, opacity" /><img src="/static/image/9-1.21b240bebd1ef1b73252381d27cae81e.png" style="filter: blur(8px); will-change: transform, opacity" /><img
                    src="/web/mb12/image/transfer"
                  />
                </div>
              </div>
              <div class="index__usercount__2PZnN undefined">
                <div class="index__private__2QUr-">
                  <i class="index__user_icon__CS-AW" :style="`background-image: url(${$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'}); background-position: 0px 0px; background-size: 100% 100%; background-repeat: no-repeat`"
                    ><span data-analytics="button" data-label="更改头像" class="index__user_lamellae__30UFA">更改头像 <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" /> </span></i
                  ><i class="index__vip_icon__158Bt" style="background-image: url('/static/image/vip-0.ac6a1ae5500fc700d33a7fbbffbe2176.png'); background-position: 0px 0px; background-size: 100% 100%; background-repeat: no-repeat"></i>
                </div>
                <div class="index__user_name__1RAED">
                  <span class="index__name_text__1Tcx7">{{ $store.state.userInfo.username }}</span>
                  <!-- <span class="index__title_des__zgNMc">加入{{$store.state.appInfo.title}}第24天</span></div>
                <div class="index__safe_level__JhHQ4">
                  <span>安全等级:<span style="margin-left: 5px">低</span></span>
                </div> -->
                </div>
                <div class="newBox" @click="$parent.goNav('/vip')">
                  <div class="profile_header_vip_bottom">
                    <div class="progress profile_header_vip_level_progress">
                      <div class="progress-bar" :style="`width: ${bfNum}%`"></div>
                      <div class="progress_percent">{{ bfNum }}%</div>
                      <div title="VIP1" class="progress_left_text">{{ $store.state.userInfo.current_vip }}</div>
                      <div title="VIP2" class="progress_right_text">{{ $store.state.userInfo.next_vip }}</div>
                    </div>
                  </div>
                </div>
                <div class="index__safe_icon__VhwnU">
                  <section><div class="index__icon__J6Rel" style="background-image: url('/static/image/phone_active.87e65aa83a68e67a730f6f075e739a30.png'); background-position: center center; background-size: 22px 22px; background-repeat: no-repeat"></div></section>
                  <section class="index__gray__3uHT_"><div class="index__icon__J6Rel" style="background-image: url('/static/image/email.9aeaf5c49ee0edfebbe1e3b322d29bab.png'); background-position: center center; background-size: 22px 22px; background-repeat: no-repeat"></div></section>
                  <section class="index__gray__3uHT_"><div class="index__icon__J6Rel" style="background-image: url('/static/image/info.a38c2024fe7a57eeb567da8a819f8b49.png'); background-position: center center; background-size: 22px 22px; background-repeat: no-repeat"></div></section>
                  <section class="index__gray__3uHT_"><div class="index__icon__J6Rel" style="background-image: url('/static/image/bank.ff9d0cefca70ab9a1b8cb8d4e18a94ee.png'); background-position: center center; background-size: 22px 22px; background-repeat: no-repeat"></div></section>
                </div>
              </div>
              <div class="index__wallet_menu__3F9Gy">
                <div class="index__userWallet__-4gsZ">
                  <p>中心钱包：</p>
                  <b class="left_than">{{ $store.state.userInfo.balance }}</b>
                </div>
                <div data-render="23" class="index__user_menu__3JKmv undefined">
                  <ul class="index__part_one__2Ya3V">
                    <li @click="$parent.goNav('/recharge')" :class="path == '/recharge' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>存款</p>
                    </li>
                    <li @click="$parent.goNav('/transfer')" :class="path == '/transfer' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>转账</p>
                    </li>
                    <li @click="$parent.goNav('/withdraw')" :class="path == '/withdraw' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>取款</p>
                    </li>
                  </ul>
                  <ul class="index__part_two__3KeRW">
                    <li @click="$parent.goNav('/bankCard')" :class="path == '/bankCard' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>我的钱包</p>
                    </li>
                    <li @click="$parent.goNav('/transRecord')" :class="path == '/transRecord' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>交易记录</p>
                    </li>
                    <li @click="$parent.goNav('/betRecord')" :class="path == '/betRecord' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>投注记录</p>
                    </li>
                    <li @click="$parent.goNav('/fanshui')" :class="path == '/fanshui' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>返水记录</p>
                    </li>

                    <li @click="$parent.goNav('/activityRecord')" :class="path == '/activityRecord' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>活动申请记录</p>
                    </li>
                    <li @click="$parent.goNav('/applyagent')" :class="path == '/applyagent' ? 'index__link_active__11H_t' : ''" v-if="$store.state.userInfo.isagent == 0">
                      <div class="index__icon__J6Rel"></div>
                      <p>申请代理</p>
                    </li>
                     <li @click="$parent.getAgentLoginUrl" :class="path == '/applyagent' ? 'index__link_active__11H_t' : ''" v-if="$store.state.userInfo.isagent == 1">
                      <div class="index__icon__J6Rel"></div>
                      <p>代理登录</p>
                    </li>
                  </ul>
                  <ul class="index__part_three__pdBTn">
                    <li @click="$parent.goNav('/center')" :class="path == '/center' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>个人资料</p>
                    </li>
                    <li @click="$parent.goNav('/message')" :class="path == '/message' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>消息中心</p>
                    </li>
                    <li @click="$parent.goNav('/welfare')" :class="path == '/welfare' ? 'index__link_active__11H_t' : ''">
                      <div class="index__icon__J6Rel"></div>
                      <p>红包</p>
                    </li>
                    <li @click="$parent.openKefu" class="null">
                      <div class="index__icon__J6Rel"></div>
                      <p>意见反馈</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="centerHead__centerContent__1K_n0">
              <div class="transiton_container" style="height: auto">
                <router-view />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return { path: null, baseURL: '', vipLis: [], bfNum: 0 };
  },
  created() {
    let that = this;
    that.path = that.$route.path;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.uservip();
  },
  methods: {
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; //当前vip充值钱
      let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
    },
    openPage(url) {
      this.$parent.openPage(url);
    },
    getAgentLoginUrl() {
      this.$parent.getAgentLoginUrl();
    },
    outLogin() {
      this.$parent.outLogin();
    },
    openDaoTime() {
      this.openDaoTime();
    },
    closeDaoTime() {
      this.$parent.closeDaoTime();
    },
    openGamePage(name, type, code) {
      this.$parent.openGamePage(name, type, code);
    },

    goNav(url) {
      this.$parent.goNav(url);
    },

    getUserInfo() {
      this.$parent.getUserInfo();
    },
    getUserInfoShowLoding() {
      this.$parent.getUserInfoShowLoding();
    },
    doCopy(msg) {
      this.$parent.doCopy(msg);
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getBalance() {
      this.$parent.getBalance();
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.showLoading();
      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfoShowLoding();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        // that.changPath(that.$route.path);
        that.path = that.$route.path;
        //
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import '/static/css/kokHomePage_81ba8019.7a99a5ae.css';
@import '/static/css/AppPage_81ba8019.70544118.css';
@import '/static/css/HomePage_793450d6.1af8985c.css';
@import '/static/css/MyCenterPage_81ba8019.9823fc5e.css';
@import '/static/css/main_81ba8019.85ebbbbe.css';
@import '/static/css/main_493df0b3.71306a96.css';
@import '/static/css/leyuCenterLeft_81ba8019.8ac3706f.css';
@import '/static/css/MyCenterPage_81ba8019.9823fc5e.css';
@import '/static/css/Transfer_81ba8019.f1b60e17.css';

@import '/static/css/Login_793450d6.6cd821f7.css';
@import '/static/css/antd_main_9b1fde68.c56beacb.css';
@import '/static/css/antd_main_81ba8019.315b4ccd.css';
@import '/static/css/antd_main_81ba8019.f3df7c67.css';
@import '/static/css/antd_main_c2e1b336.610010bf.css';
@import '/static/css/antd_main_f848cf0e.b2237fe6.css';
@import '/static/css/app.6cbe056357de3c041fcdc8b5ea75d2a6.css';
@import '/static/css/app.6cbe056357de3c041fcdc8b5ea75d2a6.css';
@import '/static/css/font.css';
@import '/static/css/othercommons_Login_Register_81ba8019.899213a8.css';
@import '/static/css/vendors_HomePage_kokHomePage_80e93ec1.533f31e7.css';

.index__user_left_kok__2nleM .index__wallet_menu__3F9Gy .index__user_menu__3JKmv > ul.index__part_two__3KeRW > li:nth-of-type(5) .index__icon__J6Rel {
  background: url('/static/image/3.983decfccd2bdc503c4c42fdf583de89.png') no-repeat;
}
.index__user_left_kok__2nleM .index__wallet_menu__3F9Gy .index__user_menu__3JKmv > ul.index__part_two__3KeRW > li:nth-of-type(6) .index__icon__J6Rel {
  background: url('/static/image/3.983decfccd2bdc503c4c42fdf583de89.png') no-repeat;
}

.index__user_left_kok__2nleM .index__wallet_menu__3F9Gy .index__user_menu__3JKmv > ul.index__part_two__3KeRW > li:nth-of-type(6).index__link_active__11H_t .index__icon__J6Rel {
  background: url('/static/image/3-1.d5283afeb84b6fee05f9fd6d682d3d11.png') no-repeat;
}
.index__user_left_kok__2nleM .index__wallet_menu__3F9Gy .index__user_menu__3JKmv > ul.index__part_two__3KeRW > li:nth-of-type(5).index__link_active__11H_t .index__icon__J6Rel {
  background: url('/static/image/3-1.d5283afeb84b6fee05f9fd6d682d3d11.png') no-repeat;
}
.index__user_left_kok__2nleM .index__wallet_menu__3F9Gy .index__user_menu__3JKmv > ul.index__part_two__3KeRW > li:nth-of-type(4).index__link_active__11H_t .index__icon__J6Rel {
  background: url('/static/image/3-1.d5283afeb84b6fee05f9fd6d682d3d11.png') no-repeat;
}
// vip

.progress {
  height: 18px;
  position: relative;
  overflow: hidden;
  background: #595959;
  border-radius: 25px;
}
.profile_header_vip_level_progress {
  height: 18px !important;
  font-size: 10px;
  // color: #595959;
  border-radius: 25px;
  overflow: visible !important;
  margin: 8px 0 24px;
  background: #c0b1b1 !important;
}

.progress {
  display: flex;
  overflow: hidden;
  background-color: #e9ecef;
}
.profile_header_vip_level_progress .progress-bar {
  border-radius: 25px;
}
.progress-bar {
  background: #888888;
  border-radius: 25px;
}
.progress-bar {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}
.profile_header_vip_level_progress .progress_percent {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  color: #fff;
}
.profile_header_vip_level_progress .progress_left_text {
  position: absolute;
  left: 0;
  bottom: calc(-100% - 8px);
}
.profile_header_vip_level_progress .progress_right_text {
  position: absolute;
  right: 0;
  bottom: calc(-100% - 8px);
}
.newBox {
  width: 180px;
  height: 64px;
  // background-color: #f4f4f5;
  color: #fff;
  font-size: 12px;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 5px;
  box-sizing: border-box;
  padding: 4px 10px;
  cursor: pointer;
}

// 上传头像
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/mine.vue